import { createReducer } from '@reduxjs/toolkit'

import type { Status } from '@/types'
import { messageHandlerReset, messageHandlerSet } from './actions'

interface IMessageHandler {
  type?: Status | undefined
  description: string | undefined
  message?: string | undefined
  notDismissable: boolean
  duration?: number
}

const initialState: IMessageHandler = {
  type: undefined,
  description: undefined,
  message: undefined,
  notDismissable: false,
  duration: undefined
}

const errorsReducer = createReducer(initialState, builder => {
  builder
    .addCase(messageHandlerSet, (state, action) => {
      state.type = action.payload.type
      state.description = action.payload.description
      state.message = action.payload.message
      state.notDismissable = action.payload.notDismissable || false
      state.duration = action.payload.duration
    })
    .addCase(messageHandlerReset, (state) => {
      state.type = undefined
      state.description = undefined
      state.message = undefined
      state.notDismissable = false
      state.duration = undefined
    })
})

export default errorsReducer
